import { ContactForm } from '@gik/contact/components/ContactForm/ContactForm';
import LiveSupport from '@gik/contact/components/LiveSupport/LiveSupport';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { PageSection } from '@gik/ui/gik/PageSection';
import React from 'react';
import BusinessInquiries from '../BusinessInquiries/BusinessInquiries';
import Connect from '../Connect/Connect';
import KnowledgeBase from '../KnowledgeBase/KnowledgeBase';
import PressInquiries from '../PressInquiries/PressInquiries';

export default function Contact() {
  const bem = useBemCN('contact');

  return (
    <PageSection {...bem()}>
      <div {...bem('form')}>
        <ContactForm />
      </div>
      <div {...bem('tiles')}>
        <LiveSupport />
        <KnowledgeBase />
        <Connect />
        <BusinessInquiries />
        <PressInquiries />
      </div>
    </PageSection>
  );
}
